const images = [
  { id: 1, src: require("../assets/politics.png"), title: "Politics" },
  { id: 2, src: require("../assets/writing.png"), title: "Writing" },
  { id: 3, src: require("../assets/reading.png"), title: "Reading" },
  { id: 4, src: require("../assets/sports.png"), title: "Sports" },
  { id: 5, src: require("../assets/finance.png"), title: "Finance" },
  { id: 6, src: require("../assets/speaking.png"), title: "Speech" },
  { id: 7, src: require("../assets/gaming.png"), title: "Gaming" },
  { id: 8, src: require("../assets/fashion.png"), title: "Fashion" },
  { id: 9, src: require("../assets/news.png"), title: "News" },
  { id: 10, src: require("../assets/design.png"), title: "Design" },
  { id: 11, src: require("../assets/history.png"), title: "History" },
];

export default images;
